import {useEffect, useState} from 'react';
import {motion} from 'framer-motion'
import {pageAnimation, gearAnimation, toggleAnimation} from '../Variants/variants'
import { faTableList, faGear} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHtml5, faCss3Alt, faJs, faReact, faSass, faEmber, faJava } from '@fortawesome/free-brands-svg-icons';
import '../CSS/project.scss'

const ProjectFilter = ({projects, setFiltered, activeButton, setActiveButton, previewGif, previewHover, setPreviewGif, setPreviewHover}) =>{
    const buttons = ["All", "HTML", "CSS", "JavaScript", "React", "Sass", "EmberJS", "Java"]
    const icons = [faTableList, faHtml5, faCss3Alt, faJs, faReact, faSass, faEmber, faJava]
    const [openGear, setOpenGear] = useState(true);

    useEffect(() =>{
        if(activeButton === "All"){
            setFiltered(projects)
            return;
        }
        const filteredArr = [];
        for(let x = 0; x < projects.length; x++){
            if(projects[x].tech.includes(activeButton)){
                filteredArr.push(projects[x]);
            }
        }
        setFiltered(filteredArr);
    }, [activeButton])

    const toggleGif = () =>{
        setPreviewGif(!previewGif);
    }

    const toggleHover = () =>{
        setPreviewHover(!previewHover);
    }

    const variant = {
        animate:{
            transition: {
                type: "spring",
                stiffness: 700,
                damping: 30
            }
        }
    }

    return(
        <motion.div className="project-filter" 
        variants={pageAnimation}
        initial="initial"
        animate="animate"
        exit="exit">
            <motion.div className={`filter-button-container ${openGear ? 'active' : ''}`}>
                {buttons.map((b, index) =>{
                    return(
                        <Button 
                        name={b}
                        icon={icons[index]}
                        setActiveButton={setActiveButton}
                        activeButton={activeButton}
                        key={b}
                        />
                    )
                })}
                <motion.div className='gear' onClick={() => setOpenGear(!openGear)}
                variants={gearAnimation}
                animate={openGear ? 'animate' : 'initial'}>
                    <FontAwesomeIcon icon={faGear}/>
                </motion.div>
            </motion.div>
            <motion.div className={`gear-background ${openGear ? 'active' : ''}`}>
                <motion.div className='gear2' onClick={() => setOpenGear(!openGear)}
                variants={gearAnimation}
                animate={openGear ? 'animate' : 'initial'}>
                    <FontAwesomeIcon icon={faGear}/>
                </motion.div>
            </motion.div>
            
            <motion.div className='switch-background'
            variants={toggleAnimation}
            initial="animate"
            animate={openGear ? 'animate' : 'initial'}>
                <motion.div className="switch-container">
                    <div className="label">Gif: </div>
                    <div className="switch" onClick={toggleGif} data-previewgif={previewGif}>
                        <motion.div 
                        className="toggle" 
                        variants={variant}
                        animate="animate"
                        layout
                        />
                    </div>
                    <div className="label">Hover: </div>
                    <div className="switch" onClick={toggleHover} data-previewhover={previewHover}>
                        <motion.div 
                        className="toggle" 
                        variants={variant}
                        animate="animate"
                        layout/>
                    </div>
                </motion.div>
            </motion.div>
        </motion.div>
    )
}

export default ProjectFilter;

const Button = ({ name, icon, setActiveButton, activeButton}) =>{
    return(
        <motion.div className='filter-buttons'
            onClick={() => setActiveButton(name)}
            animate={activeButton === name ? {color: "var(--color-LB)"}: ""}
            transition={{duration: .5}}>
                {name}
            <FontAwesomeIcon icon={icon}/>
            {activeButton === name &&(
                <motion.div className='selected' layoutId='selected'/>
            )}
        </motion.div>
    )
}